import React from "react";
import { useTheme } from "@fluentui/react";
import { SearchBox } from "@fluentui/react-components";
import { usePcpSearchBoxStyles } from "./baseComponents.styles";
import { SearchRegular } from "@fluentui/react-icons";
import { SearchBoxProps } from "@fluentui/react-search";


export const PcpSearchBox = (props: SearchBoxProps): JSX.Element => {
    const theme = useTheme();
    const styles = usePcpSearchBoxStyles();

    return (
        <SearchBox
            {...props}
            contentBefore={<SearchRegular />}
            size="large"
            type={"text"}
            root={{ className: styles.root }}
            input={{ className: styles.input }}
        />
    );
};
